import { ControllerAdditionalInfo } from 'src/types';

type PossibleValuesType = {
  id?: string;
  displayName: string;
  value?: string;
};

type getActiveAndNewModeTypes = {
  controllerAdditionalInfo?: ControllerAdditionalInfo[];
  possibleValues: PossibleValuesType[];
  activeMode?: any;
  values: any;
};

export const getActiveAndNewMode = ({
  controllerAdditionalInfo,
  activeMode,
  possibleValues,
  values,
}: getActiveAndNewModeTypes) => {
  const findActiveMode = controllerAdditionalInfo?.find((tag) => tag.id === activeMode?.tagId);
  const valueFlagTrue = findActiveMode?.advancedTagMapping?.userDefinedValues?.find(
    (value) => value.valueFlag
  );
  const valueFlagFalse = findActiveMode?.advancedTagMapping?.userDefinedValues?.find(
    (value) => !value.valueFlag
  );

  const activeModeTag = {
    tagId: activeMode?.tagId,
    oldValue: valueFlagTrue?.value,
    newValue: valueFlagFalse?.value,
  };

  const modeValue = values?.mode;
  const newSelectedMode = possibleValues?.find(
    (mode) => mode.displayName?.replace(/\s/g, '') === modeValue?.replace(/\s/g, '')
  );

  const selectedModeTag = controllerAdditionalInfo?.find((tag) => tag.id === newSelectedMode?.id);

  const newValueFlagTrue = selectedModeTag?.advancedTagMapping?.userDefinedValues?.find(
    (value) => value.valueFlag
  );
  const newValueFlagFalse = selectedModeTag?.advancedTagMapping?.userDefinedValues?.find(
    (value) => !value.valueFlag
  );

  const newSelectedModeTag = {
    tagId: selectedModeTag?.id,
    oldValue: newValueFlagFalse?.value,
    newValue: newValueFlagTrue?.value,
  };

  const isMultiplePossibleValues = possibleValues.length > 2;
  const isActiveModeBooleanTag =
    findActiveMode?.advancedTagMapping?.dataTypeTagMapping === 'BOOLEAN';
  const isNewSelectedModeBooleanTag =
    selectedModeTag?.advancedTagMapping?.dataTypeTagMapping === 'BOOLEAN';
  if (!isMultiplePossibleValues || !isActiveModeBooleanTag || !isNewSelectedModeBooleanTag)
    return false;

  return {
    activeModeTag,
    newSelectedModeTag,
  };
};
